import {jsx as _jsx} from "react/jsx-runtime";import {Suspense} from 'react'
import activityLibraryQuery, {

} from '~/__generated__/ActivityLibraryQuery.graphql'
import useQueryLoaderNow from '../../hooks/useQueryLoaderNow'
import {Loader} from '../../utils/relay/renderLoader'
import {ActivityLibrary} from './ActivityLibrary'

const ActivityLibraryRoute = () => {
  const queryRef = useQueryLoaderNow(activityLibraryQuery)

  return (
    _jsx(Suspense, { fallback: _jsx(Loader, {} ), children: queryRef && _jsx(ActivityLibrary, { queryRef: queryRef,} )})
  )
}

export default ActivityLibraryRoute
